module.exports = __webpack_public_path__ + "img/frame (129).5e147533.jpg";